import React from 'react';

import useRouterState from './useRouterState';

const useGetSignInServiceEmail = () => {
  const [externalUserData, setExternalUserData] = React.useState<{
    client_email?: string;
    system_identifier?: string;
  }>({
    client_email: undefined,
    system_identifier: undefined,
  });

  useRouterState({
    onChange: (n, location) => {
      if (location.state) {
        if (location.state.client_email && location.state.system_identifier) {
          setExternalUserData({
            client_email: location.state.client_email,
            system_identifier: location.state.system_identifier,
          });
        }
      }
    },
    dependencies: [],
  });

  return externalUserData;
};

export default useGetSignInServiceEmail;
